import { SVGProps } from "react";
import cn from "classnames";
import { ReactComponent as LogoLight } from "../../police-narratives-ai-light-mode.svg";
import { ReactComponent as LogoDark } from "../../police-narratives-ai-dark-mode.svg";

type LogoProps = SVGProps<SVGSVGElement> & { title?: string };

/**
 * Theme-aware brand logo. Both variants render and CSS picks one based on
 * the data-theme attribute, so it stays correct under ForceLightTheme pages
 * and flips instantly with the theme toggle.
 */
export default function Logo({ className, ...props }: LogoProps) {
  return (
    <>
      <LogoLight {...props} className={cn(className, "dark:hidden")} />
      <LogoDark {...props} className={cn(className, "hidden dark:inline")} />
    </>
  );
}
